<template>
  <el-dialog
    :visible.sync="visible"
    width="1000px"
    title="编辑分类"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
  >
    <div class="dict-value-setting">
      <div class="dict-setting-header">
        <div class="tool-content-btn" @click="addHandle">
          <img :src="addImg" alt="" />
          <span>增加</span>
        </div>
        <div class="tool-content-btn" @click="clearHandle">
          <i class="el-icon-delete"></i>
          <span>删除全部</span>
        </div>
        <div class="tool-content-btn upload-btn">
          <img :src="importImg" alt="" />
          <span>导入excel</span>
          <input type="file" accept=".xlsx" class="upload-input" @change="importHandle" />
        </div>
        <div class="tool-content-btn" @click="exportHandle">
          <img :src="exportImg" alt="" />
          <span>导出excel</span>
        </div>
        <div class="tool-content-btn tip-desc">
          <span>每个近义词以“|”符号分隔</span>
        </div>
        <el-popover placement="bottom-end" title="" width="500" trigger="hover">
          <el-button slot="reference" type="text" :style="{ float: 'right' }">
            <span>示例</span>
          </el-button>
          <dictValueEditor :dictClassifyValue="previewVal" />
        </el-popover>
      </div>
      <div class="dict-setting-content" ref="dictSettingContentRef">
        <div id="spreadsheet"></div>
      </div>
    </div>

    <span slot="footer">
      <el-button @click="visible = false">
        <span>取消</span>
      </el-button>
      <el-button type="primary" @click="confirmHandle">
        <span>确认</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import exportImg from '@/assets/img/导出gray.png';
import importImg from '@/assets/img/导入gray.png';
import addImg from '@/assets/img/增加@2x.png';
import dictValueEditor from '../../fieldEditorComponents/dictValueEditor';

import Xlsx from 'xlsx';
import { exportExcel } from '@/lib/utils';
import jspreadsheet from 'jspreadsheet-ce';
import 'jspreadsheet-ce/dist/jspreadsheet.css';
import 'jsuites/dist/jsuites.css';

export default {
  components: { dictValueEditor },
  data() {
    return {
      exportImg,
      importImg,
      addImg,
      importing: false,
      previewVal: [
        { labelName: '中学', children: '初级中学|高级中学' },
        { labelName: '广东省', children: '广州市|深圳市|珠海市|佛山市|惠州市...' }
      ],
      jspreadsheetEl: null
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    dictClassifyValue: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    }
  },
  beforeDestroy() {
    if (this.jspreadsheetEl) {
      this.jspreadsheetEl.destroy();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initJspreadsheet(this.dictClassifyValue);
    });
  },
  methods: {
    confirmHandle() {
      this.$emit('change', this.getDictValue());
      this.visible = false;
    },
    initJspreadsheet(val = []) {
      let data = [];
      if (val.length) {
        data = val.map(o => [o.labelName, o.children]);
      }
      const addEmptyCount = 5 - data.length;
      for (let i = 0; i < addEmptyCount; i++) {
        data.push([]);
      }
      if (this.jspreadsheetEl) {
        this.jspreadsheetEl.setData(data);
      } else {
        this.jspreadsheetEl = jspreadsheet(document.getElementById('spreadsheet'), {
          data,
          columns: [
            { type: 'text', title: '分类名称', width: 120 },
            { type: 'text', title: '近义词', width: 746 },
            { type: 'text', title: '操作', width: 40, align: 'center' }
          ],
          defaultColAlign: 'left',
          allowExport: false,
          columnSorting: false,
          columnResize: false,
          rowDrag: false,
          allowDeletingAllRows: true,
          allowInsertColumn: false,
          allowManualInsertColumn: false,
          allowDeleteColumn: false,
          allowRenameColumn: false,
          contextMenu: (obj, x, y) => {
            if (y === null) {
              return;
            }
            return [
              { title: '在此前插入行', onclick: () => obj.insertRow([], parseInt(y), 1) },
              { title: '在此后插入行', onclick: () => obj.insertRow([], parseInt(y)) },
              { title: '删除选中行', onclick: () => obj.deleteRow(parseInt(y)) }
            ];
          },
          onselection: (obj, startX, startY, endX, endY) => {
            if (startX !== 2 || startX !== endX || startY !== endY) {
              return;
            }
            this.jspreadsheetEl.deleteRow(parseInt(startY));
          }
        });
      }
    },
    getDictValue() {
      if (!this.jspreadsheetEl) {
        return [];
      }
      const dictClassifyValue = this.jspreadsheetEl.getData().map(rowInfo => {
        return { labelName: (rowInfo[0] || '').trim(), children: rowInfo[1] };
      });
      const arr = dictClassifyValue.filter(item => item.labelName);
      const m = new Map();
      arr.forEach(item => {
        if (m.has(item.labelName)) {
          const preItem = m.get(item.labelName);
          let childTextArr = (preItem.children || '').split(/\||丨/).map(text => text.replace(/[ \n\r\t]/g, ''));
          childTextArr = [
            ...childTextArr,
            ...(item.children || '').split(/\||丨/).map(text => text.replace(/[ \n\r\t]/g, ''))
          ].filter(text => !!text);
          m.set(item.labelName, { labelName: item.labelName, children: [...new Set(childTextArr)].join('|') });
        } else {
          const childTextArr = (item.children || '')
            .split(/\||丨/)
            .map(text => text.replace(/[ \n\r\t]/g, ''))
            .filter(text => !!text);
          m.set(item.labelName, { ...item, children: [...new Set(childTextArr)].join('|') });
        }
      });
      return [...m.keys()].map(key => {
        return m.get(key);
      });
    },
    async importHandle(event) {
      if (this.importing) {
        return;
      }
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      event.target.value = '';
      try {
        this.importing = true;
        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = resolve;
          reader.onerror = reject;
          reader.readAsArrayBuffer(file);
        });
        const workbook = Xlsx.read(result.target.result, { type: 'buffer' });
        let sheetName = 'sheet1';
        if (workbook.Sheets) {
          if (!workbook.Sheets[sheetName]) {
            sheetName = 'Sheet1';
            if (!workbook.Sheets[sheetName]) {
              throw new Error('excel解析失败，请先导出excel并修改后再导入');
            }
          }
        } else {
          throw new Error('excel解析失败，请先导出excel并修改后再导入');
        }
        const arr = Xlsx.utils
          .sheet_to_json(workbook.Sheets[sheetName])
          .filter(item => {
            return !!item['分类名称'] || item['分类名称'] === 0;
          })
          .map(item => {
            return {
              labelName: String(item['分类名称'] || '').replace(/[ \n\r\t]/g, ''),
              children: String(item['近义词'] || '').replace(/[ \n\r\t]/g, '')
            };
          })
          .filter(item => {
            return !!item.labelName;
          });
        if (arr.length === 0) {
          throw new Error('导入失败，excel为空。');
        }
        this.jspreadsheetEl.setData(arr.map(o => [o.labelName, o.children]));
      } catch (err) {
        this.$error(err);
      } finally {
        this.importing = false;
      }
    },
    exportHandle() {
      const sheetHeader = ['分类名称', '近义词'];
      const excelData = [sheetHeader];
      this.jspreadsheetEl.getData().forEach(rowInfo => {
        excelData.push([rowInfo[0], rowInfo[1]]);
      });
      exportExcel(Xlsx.utils.aoa_to_sheet(excelData), `标签分类.xlsx`);
      this.$message.success('excel导出成功');
    },
    clearHandle() {
      this.jspreadsheetEl.setData([[]]);
    },
    addHandle() {
      if (this.jspreadsheetEl.getData().length > 0) {
        this.jspreadsheetEl.insertRow();
      } else {
        this.clearHandle();
      }
      this.$nextTick(() => {
        this.$refs.dictSettingContentRef.scrollTop = this.$refs.dictSettingContentRef.childNodes[0].clientHeight;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.dict-value-setting {
  .dict-setting-content {
    position: relative;
    max-height: 800px;
    overflow: auto;
    margin-top: 10px;

    &::-webkit-scrollbar {
      display: none;
    }
    ::v-deep #spreadsheet {
      width: 100%;

      .jexcel > thead > tr > td {
        background-color: #f8fafd;
        line-height: 32px;
      }

      .jexcel > tbody > tr > td:first-child {
        background-color: #f8fafd;
      }

      .jexcel > tbody > tr > td:last-child {
        cursor: pointer;

        &::before {
          font-size: 12px;
          content: 'X'; // 删除
          color: #409eff;
        }
      }
    }
  }
  .dict-setting-header {
    .tool-content-btn {
      display: inline-block;
      padding: 5px;
      padding-left: 0;
      font-size: 12px;
      cursor: pointer;
      margin-right: 10px;

      &.upload-btn {
        position: relative;
        overflow: hidden;
        vertical-align: bottom;

        .upload-input {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          z-index: 1;
          cursor: pointer;
        }
      }

      &.tip-desc {
        font-size: 12px;
        color: rgba(44, 52, 67, 0.5);
        cursor: auto;
        margin-left: 2px;
      }

      & > .el-icon-delete {
        position: relative;
        top: 1px;
        color: #999;
        font-size: 14px;
        margin-right: 4px;
      }

      & > img {
        position: relative;
        top: 2px;
        width: 14px;
        margin-right: 4px;
      }
    }
  }
}
</style>
